import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { IoIosArrowForward } from "react-icons/io";
import { useSelector } from "react-redux";
import HeaderContainer from "../../components/UI/‌Header/HeaderContainer";
import { t } from "i18next";
import Colors from "../../constant/Colors";
import ReactToPrint from "react-to-print";
import dayjs from "dayjs";
import { store } from "../../App";
import { editCurrentUser } from "../../store/actions/usersAction";
import { fetchLastMembership } from "../../store/actions/membershipsAction";
import { ActivityIndicator } from "react-native-web";
import { showInIQD } from "../../customFunction/Numeral/CurrencyFormat";

export default function CompleteBuyPackageScreen() {
  const currentUser = useSelector((state) => state.users.currentUser);
  const [lastMembership, setLastMembership] = useState()

  useEffect(() => {
    setup()
  }, []);

  const setup = async () => {
    try {
      if (currentUser) {
        const last = await fetchLastMembership(currentUser._id)
        console.log(last)
        setLastMembership(last)
      }
    } catch (e) {
      alert('ببورە هەڵەیەک ڕویدا')
    }
  }

  return (
    <div className='flex flex-col items-center justify-center w-full '>

      {lastMembership && <Container lastMembership={lastMembership} currentUser={currentUser} />}
      {!lastMembership && <ActivityIndicator size='large' style={{ marginTop: 100 }} />}
    </div>
  );
}

const Container = ({ currentUser, lastMembership }) => {
  const componentRef = useRef();

  return (
    <div className='w-4/5 mt-8 border'>
      <div style={{ display: "none" }}>
        <ComponentToPrint lastMembership={lastMembership} currentUser={currentUser} ref={componentRef} />
      </div>
      <InputContainer />
      <ReactToPrint
        onPrintError={() => { }}
        trigger={PrintButton}
        content={() => componentRef.current}
      />
    </div>
  );
};

const InputContainer = ({ currentUser }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{ backgroundColor: "#dde6e9" }}
      className='items-center justify-center py-24'>
      <div className='flex flex-col items-center justify-center w-full '>
        <img src='https://i.gifer.com/ISSh.gif' className='h-40 w-60' />
      </div>
    </div>
  );
};
const PrintButton = () => {
  return (
    <div
      style={{ backgroundColor: Colors.mainPurple }}
      className='flex flex-row items-center justify-end w-full p-6 cursor-pointer hover:opacity-90'>
      <h1 className='mr-1 font-bold text-white'>{t('print')}</h1>
      <IoIosArrowForward color='#fff' />
    </div>
  );
};

const ComponentToPrint = React.forwardRef((props, ref) => {
  const { currentUser, lastMembership } = props;

  const features = { 0: "Gym", 1: "Swim" };
  const style = {
    fontSize: 17,
    fontFamily: "Montserrat-Bold",
    color: "#000",
    position: "absolute",
  };
  const money = lastMembership.package.price.value + "$";
  return (
    <div ref={ref}>
      <div
        style={{
          bottom: 999,
          left: 415,
          ...style,
        }}>
        {money}
      </div>
      <div
        style={{
          bottom: 997,
          left: 48,
          ...style,
        }}>
        {currentUser.phone}
      </div>
      {/* //! top 2 */}
      <div
        style={{
          bottom: 924,
          left: 415,
          ...style,
        }}>
        {currentUser.name}
      </div>
      <div
        style={{
          bottom: 924,
          left: 48,
          ...style,
        }}>
        {lastMembership.package.features.map((a) => features[a]).join(", ")}
      </div>
      {/* //! top 3 */}
      <div
        style={{
          bottom: 852,
          left: 415,
          ...style,
        }}>
        {currentUser.bioStarID}
      </div>
      <div
        style={{
          bottom: 852,
          left: 48,
          ...style,
        }}>
        {lastMembership.numberId} - ({lastMembership.receiptId})
      </div>

      {/* //!Bottom */}
      <div
        style={{
          bottom: 40,
          left: 575,
          ...style,
          fontSize: 14,
        }}>
        {dayjs().format("DD/MM/YYYY")}
      </div>

      <div
        style={{
          bottom: 40,
          left: 352,
          ...style,
          fontSize: 14,
        }}>
        {dayjs(currentUser.start_datetime).utc().format("DD/MM/YYYY")}
      </div>
      <div
        style={{
          bottom: 40,
          left: 170,
          ...style,
          fontSize: 14,
        }}>
        {dayjs(currentUser.expiry_datetime).utc().format("DD/MM/YYYY")}
      </div>
      <img
        alt=""
        style={{ width: "100%", height: 1120, zIndex: 1 }}
        src={require('../../assets/INVOICE_page-0001-min.jpg')}
      />
    </div>
  );
});